import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-yoga': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_yoga_female_scratch_card_before_the_paywall~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_yoga_female_scratch_card_before_the_paywall'
					),
			},
		},
	},
]

export default config
